<template>
    <div class="card">
        <div class="p-grid" style="padding: 1em 1em 1em 1em;">
            <div class="ttitle">{{$store.state.title[i18n.locale()]}}</div>
            <div class="p-col-12">
				<DataTable :value="products"  stripedRows class="p-datatable-customers p-datatable-sm"
                        dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" :filters="filters" scrollable scrollHeight="400px">
					<template #header>
						<div class="table-header">
							<div>{{$t('Records')}}: {{ products.length }}</div>
							<span class="p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText v-model="filters['global']" :placeholder="$t('Search')+'...'" />
                            </span>
							<div>
								<Button icon="pi pi-plus" class="p-button-rounded p-button-secondary p-mr-2 p-mb-2" v-tooltip.bottom="$t('New')" @click="New" v-if="insert"/>
								<Button icon="pi pi-refresh" class="p-button-rounded p-button-secondary p-mr-2 p-mb-2" v-tooltip.bottom="$t('Refresh')" @click="Start"/>
							</div>
						</div>
					</template>
					<Column field="doc" :header="$t('Personal DOC ID')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.doc}}
						</template>
					</Column>
					<Column field="policy" :header="$t('Policy number')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.policy}}
						</template>
					</Column>
					<Column field="status" :header="$t('Status')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.status}}
						</template>
					</Column>
					<Column field="valid" :header="$t('Valid from')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{convfech(slotProps.data.valid)}}
						</template>
					</Column>
					<Column field="long" :header="$t('Long')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.long}}
						</template>
					</Column>
					<Column field="name" :header="$t('Name Client')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.name}}
						</template>
					</Column>
					<Column field="type" :header="$t('Type')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.type}}
						</template>
					</Column>
					<Column field="premuim" :header="$t('Premuim')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{moneda(slotProps.data.premium)}}
						</template>
					</Column>
					<Column field="date" :header="$t('Date of Sale')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{convfech(slotProps.data.date)}}
						</template>
					</Column>
					<Column field="make" :header="$t('Make&Model')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.make}}
						</template>
					</Column>
					<Column field="year" :header="$t('Year')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.year}}
						</template>
					</Column>
					<Column field="plate" :header="$t('Plate')" headerStyle="width: 120px">
						<template #body="slotProps">
							{{slotProps.data.plate}}
						</template>
					</Column>
					<Column :header="$t('Actions')" headerStyle="width: 120px">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" class="p-button-rounded  p-button-secondary p-mr-2" @click="Edit(slotProps.data)" v-if="edit"  v-tooltip.bottom="$t('Edit')"/>
							<Button icon="pi pi-trash" class="p-button-rounded p-button-secondary" @click="confirmDeleteProduct(slotProps.data)" v-if="del"  v-tooltip.bottom="$t('Delete')"/>
						</template>
					</Column>
				</DataTable>

				<Dialog v-model:visible="productDialog" :style="{width: size}" :header="$t('Edit')" :modal="true" class="p-fluid" :maximizable="true">
					<br>
                    <div class="p-field">
						<div class="p-grid">
							<div class="p-col-6 p-md-6 p-lg-4">
								<label for="name">{{$t('Personal DOC ID')}}</label>
								<InputText v-model="product.doc"/>						
							</div>
							<div class="p-col-12 p-md-12 p-lg-4">
								<label for="name">{{$t('Policy number')}}</label>
								<InputText id="name" v-model="product.policy"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-4">
								<label for="name">{{$t('Status')}}</label>
								<InputText id="name" v-model="product.status"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-4">
								<label for="icon">{{$t('Valid from')}}</label>
								<InputText id="name" v-model="product.valid" type="date"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-4">
								<label for="name">{{$t('Long')}}</label>
								<InputText id="name" v-model="product.long"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-4">
								<label for="icon">{{$t('Date of Sale')}}</label>
								<InputText id="name" v-model="product.date" type="date"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-12">
								<label for="icon">{{$t('Name Client')}}</label>
								<InputText id="name" v-model="product.name"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-3">
								<label for="icon">{{$t('Type')}}</label>
								<InputText id="name" v-model="product.type"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-4">
								<label for="icon">{{$t('Make&Model')}}</label>
								<InputText id="name" v-model="product.make"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-2">
								<label for="icon">{{$t('Year')}}</label>
								<InputText id="name" v-model="product.year" type="number"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-3">
								<label for="icon">{{$t('Plate')}}</label>
								<InputText id="name" v-model="product.plate"/>
							</div>
							<div class="p-col-12 p-md-12 p-lg-3">
								<label for="icon">{{$t('Premium')}}</label>	
								<InputNumber v-model="product.premium" inputId="currency-us" mode="currency" currency="USD" locale="en-US" />
							</div>
							<div class="p-col-12 p-md-12 p-lg-4">
								<div v-if="product.img">
									<img style="width: 150px;" :src="url+'upload/'+product.img" @click="View(product.img)"/>
									<Button icon="pi pi-trash" class="p-button-rounded p-button-secondary" @click="Delimg(1,product.img)" v-tooltip.bottom="$t('Delete')"/>
								</div>
								<div v-else>
									<FileUpload :chooseLabel="$t('Imagen')" uploadLabel="Cargar" mode="basic" :name="'img_'+token" :url="url+'upload.php'"  accept="image/jpeg,image/jpg" :maxFileSize="100000000" @upload="Uploader(1,'img_'+token)" :auto="true"/>
								</div>
							</div>	
							<div class="p-col-12 p-md-12 p-lg-4">
								<div v-if="product.pdf">
									<img style="width: 50px;" src="images/pdf.png" @click="View(product.pdf)"/>
									<Button icon="pi pi-trash" class="p-button-rounded p-button-secondary" @click="Delimg(2,product.pdf)" v-tooltip.bottom="$t('Delete')"/>
								</div>
								<div v-else>
									<FileUpload :chooseLabel="$t('PDF')" uploadLabel="Cargar" mode="basic" :name="'pdf_'+token" :url="url+'upload.php'"  accept="application/pdf" @upload="Uploader(2,'pdf_'+token)" :auto="true"/>
								</div>
							</div>	
						</div>
					</div>
					<template #footer>
						<Button :label="$t('Save')" icon="pi pi-check" class="p-button-secondary" @click="Save()" />
						<Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-secondary" @click="productDialog = false"/>
					</template>
				</Dialog>

				<Dialog v-model:visible="deleteProductDialog" :style="{width: size}"  :header="$t('Confirm')" :modal="true">
					<br>
                    <div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
						<span v-if="product">{{$t('Are you sure you want to delete?')}}</span>
					</div>
					<template #footer>
						<Button :label="$t('Yes')" icon="pi pi-check" class="p-button-secondary" @click="Delete" />
						<Button :label="$t('No')" icon="pi pi-times" class="p-button-secondary" @click="deleteProductDialog = false"/>
					</template>
				</Dialog>

			</div>
		</div>
	</div>

</template>

<script>
	import API from "../service/API";
	var Consult = new API('Bonaire','Client');
	import Token from "uuid-token-generator";
	import { useI18nPlugin } from '@unify/vuex-i18n';

	export default {
		data() {
			return {
				i18n: null,
				newid: false,
				search: null,
				options: null,
				option: null,
				insert: false,
				edit: false,
				del: false,
				products: [],
				productDialog: false,
				deleteProductDialog: false,
				deleteProductsDialog: false,
				product: {},
				selectedCustomers: null,
				filters: {},
				size: '60vw',
				token: null,
				url: process.env.VUE_APP_API,
			}
		},
		productService: null,
		created() {
			this.i18n = useI18nPlugin();
			this.$store.commit('Validate',this.$route);
			if (this.$store.state.mobile){this.size = '90vw';}
			const tokgen = new Token(256);
			this.token = tokgen.generate();
			this.Start();

		},
		mounted() {
			
		},
		methods: {
			Start() {
				this.product = [];
				Consult.Ini().then(response => {
					//this.$store.state.error = response;
					this.insert = response.insert;
					this.edit = response.edit;
					this.del = response.delete;
					this.products = response.result;
					const tokgen = new Token(256);
					this.token = tokgen.generate();
					this.$store.commit('Loading');
				}); 
			},
			New() {
				this.newid = true;
				this.product = {
					name: null,
					en: null,
					es: null,
					activo: true,
                    ord: 0,
				};
				this.productDialog = true;
			},
			Edit(product) {
				this.newid = false;
				this.product = {...product};
				this.productDialog = true;
			},
			Save() {
				if ( this.product.name == null || this.product.name == '') {
					this.$toast.add({severity:'error', summary: this.$t('Message'), detail: this.$t('Incomplete data'), life: 5000});
				} else {	
					let condition = 'UPD';
                    if (this.newid ) { condition = 'INS'; }
					Consult.Process(condition,{
						inf: this.product,
					}).then(response => {
						//this.$store.state.error = response;
						this.$store.commit('Loading');
						this.$toast.add(Consult.Mens(response.result,this.i18n.locale()));
						if (response.result) {
							this.productDialog = false;
							this.Start();
						} 
					});
				}
			},
			confirmDeleteProduct(product) {
				this.product = product;
				this.deleteProductDialog = true;
			},
			Delete() {
				Consult.Process('DEL',{
					inf: 	this.product.id
				}).then(response => {
					//this.$store.state.error = response;
					this.$store.commit('Loading');
					this.$toast.add(Consult.Mens(response.result,this.i18n.locale()));
					if (response.result) {
						this.deleteProductDialog = false;
						this.Start();
					} 				
				});
			},
			View(index){
				window.open(this.url+'upload/'+index, '_blank');
			},

			Uploader(cas,data) {
				Consult.Process('Add',{
					inf: data,
				}).then(response => {
					//this.$store.state.error =response;
					if(response.result){	
						if(cas==1){this.product.img = response.result;}
						if(cas==2){this.product.pdf = response.result;}
					} 
					const tokgen = new Token(256);
					this.token = tokgen.generate();
					this.$store.commit('Loading');
				});
			},
			Delimg(cas,img) {
				Consult.Process('Delpdf',{
					inf: img,
				}).then(response => {
					//this.$store.state.error =response;
					this.$toast.add(Consult.Mens(response.result,this.i18n.locale()));
					if(cas==1){this.product.img = null;}
					if(cas==2){this.product.pdf = null;}
					const tokgen = new Token(256);
					this.token = tokgen.generate();
					this.$store.commit('Loading');
				});			
			},
			moneda(number){
				if(number){
					return new Intl.NumberFormat("en", {style: "currency", currency: 'USD'}).format(parseFloat(number).toFixed(2));
				} else { return '-';}
			},
			convfech(fecha){
				return fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');
			},





		}
	}
</script>

<style scoped lang="scss">
.ttitle{
    font-family: 'Rajdhani', sans-serif;
    font-size: calc(0.7rem + 1vw);
    font-weight: 600;
    color: #2b3b80;
    padding: 1em 0em 1em 0.5em;
}
.text-title{
        font-family: 'Rajdhani', sans-serif;
        font-size: calc(0.7rem + 1vw);
        font-weight: 600;
        color: #2b3b80;
    }

	::v-deep(.p-progressbar) {
	height: .5rem;
	background-color: #D8DADC;

	.p-progressbar-value {
		background-color: #607D8B;
	}
}

.p-datatable .p-column-filter {
	display: none;
}

.table-header {
	display: flex;
	justify-content: space-between;
}

::v-deep(.p-datatable.p-datatable-customers) {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}

	.p-paginator {
		padding: 1rem;
	}

	.p-datatable-thead > tr > th {
		text-align: left;
	}

	.p-datatable-tbody > tr > td {
		cursor: auto;
	}

	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
	display: none;
}

.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-qualified {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-unqualified {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-negotiation {
		background: #FEEDAF;
		color: #8A5340;
	}

	&.status-new {
		background: #B3E5FC;
		color: #23547B;
	}

	&.status-renewal {
		background: #ECCFFF;
		color: #694382;
	}

	&.status-proposal {
		background: #FFD8B2;
		color: #805B36;
	}
}

.p-progressbar-value.ui-widget-header {
	background: #607d8b;
}

@media (max-width: 640px) {
	.p-progressbar {
		margin-top: .5rem;
	}
}

.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}

.orders-subtable {
	padding: 1rem;
}

.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}

.order-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.order-delivered {
		background: #C8E6C9;
		color: #256029;
	}

	&.order-cancelled {
		background: #FFCDD2;
		color: #C63737;
	}

	&.order-pending {
		background: #FEEDAF;
		color: #8A5340;
	}

	&.order-returned {
		background: #ECCFFF;
		color: #694382;
	}
}

@media screen and (max-width: 960px) {
	::v-deep(.p-datatable) {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}

			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;

					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}

					.p-progressbar {
						margin-top: .5rem;
					}
				}
			}
		}
	}
}
</style>